import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../lib/api";

// THE duck's QR code, drawn from the matrix the backend serves (/share/:id/qr.json) — the same matrix the 3MF paints
// on the underside, so the passport, the Rollo label, the sticker and the printed duck all carry one identical code.
export function useQrCode(id) {
  const [qr, setQr] = useState(null);

  useEffect(() => {
    let alive = true;
    if (!id) return undefined;
    axios
      .get(`${API}/share/${id}/qr.json`)
      .then(({ data }) => alive && setQr(data))
      .catch(() => alive && setQr(null));
    return () => {
      alive = false;
    };
  }, [id]);

  return qr;
}

// `size` is any CSS length (e.g. "22mm"); `quiet` is the light border in modules.
export const QrMatrix = ({ qr, size = "22mm", quiet = 2, dark = "#000000", light = "#ffffff", testid }) => {
  if (!qr?.matrix?.length) {
    return <div data-testid={testid ? `${testid}-placeholder` : undefined} style={{ width: size, height: size, background: light }} />;
  }
  const n = qr.size + 2 * quiet;
  return (
    <svg data-testid={testid} viewBox={`0 0 ${n} ${n}`} width={size} height={size} shapeRendering="crispEdges" role="img" aria-label={qr.url}>
      <rect x="0" y="0" width={n} height={n} fill={light} />
      {qr.matrix.map((row, i) =>
        row.map((on, j) =>
          on ? <rect key={`${i}-${j}`} x={j + quiet} y={i + quiet} width="1" height="1" fill={dark} /> : null,
        ),
      )}
    </svg>
  );
};
